export default "__VITE_ASSET__DhPoIaC0__"